export default "__VITE_ASSET__CYx0734I__"